<template>
    <div
        class="field-wrapper w-full"
        @click="$refs.input.focus()"
        :class="{ hasValue: value, hasErrors: errors.length, dark }"
    >
        <input
            v-bind="$attrs"
            :name="name"
            autocomplete="off"
            ref="input"
            :type="typeInput"
            v-model="value"
            @focus="errors = []"
            @input="$emit('input', $event.target.value)"
        />
        <div class="field-placeholder">
            <span>{{ placeholder }}</span>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        name:{
            type: String,
            required:false
        },
        placeholder: {
            type: String,
            required: true
        },
        initialValue: {
            required: false,
            default: ""
        },
        initialErrors: {
            type: Array,
            required: false,
            default: () => []
        },
        handleChange: {
            type: Function
        },
        dark:{
            type: Boolean,
        },

    },

    data() {
        return {
            value: this.initialValue,
            errors: this.initialErrors,
        };
    },
    computed: {
        typeInput(){
            return this.name == 'dateBirth' ? 'date' : 'text';
        }
    },
    watch: {
        value: function(value) {
            const name = this.name;
            this.$emit("handle-change", { value, name });
        }
    }
};
</script>

<style lang="scss" scoped>
.dark{

    &:hover{
        border: 1px solid white!important;
        border-radius: 4px;
    }

    input{
        border: 1px solid #bfbfbf!important;
        color: white!important;
    }
    input:focus {
        border:1px solid white!important;
    }
    .field-placeholder{
        color: #80868b!important;
    }
    .field-placeholder span {
        background: #0f304d!important;
        color: #999!important;
    }
    input:not([disabled]):focus~.field-placeholder {
        color:white!important;
        span {
            color: white!important;
        }
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
    border: 1px solid white!important;
    -webkit-text-fill-color: white!important;
    box-shadow: 0 0 0px 1000px #0f304d inset;
    -webkit-box-shadow: 0 0 0px 1000px #0f304d inset;
    transition: background-color 5000s ease-in-out 0s;
    }
}
::-webkit-calendar-picker-indicator {
    filter: invert(1);
    opacity: 0.5;
}
.field-wrapper {
    position: relative;
    height: 44px;
    cursor: text;
    &:hover{
        border: 1px solid #a5a9ad;
        border-radius: 4px;
        &.hasErrors {
            border: 1px solid #cc0000;
        }
    }
}

.field-wrapper input {
    /* border: 1px solid #656662; */
    border: 1px solid #a5a9ad;
    padding: 15px;
    border-radius: 4px;
    width: 100%;
    height: 100%;
    background-color: transparent;
    color: black;
}

.field-wrapper input:focus {
    border:1px solid #999b9c;
}

.field-wrapper.hasErrors input {
    border: 1px solid #cc0000;
}

.field-wrapper .field-placeholder {
    font-size: 14px;
    position: absolute;
    bottom: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #80868b;
    left: 8px;
    padding: 0 8px;
    -webkit-transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
        opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
        opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
    text-align: left;
    width: 100%;
}

.field-wrapper .field-placeholder span {
    background: #f8f8f8;
    padding: 0px 8px;
    color: black;
    font-weight: normal;
}

.field-wrapper input:not([disabled]):focus ~ .field-placeholder {
    color: white;
    span {
        color: black;
    }
}

.field-wrapper input:not([disabled]):focus ~ .field-placeholder,
.field-wrapper.hasValue input:not([disabled]) ~ .field-placeholder {
    -webkit-transform: scale(0.75) translateY(-33px) translateX(-16%);
    transform: scale(0.75) translateY(-33px) translateX(-16%);
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: 1px solid black;
  -webkit-text-fill-color: black;
  box-shadow: 0 0 0px 1000px #f8f8f8 inset;
  -webkit-box-shadow: 0 0 0px 1000px #f8f8f8 inset;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
